/**
 * Shared transcript bubble styling for call conversation views
 * (Shift Report Note, 24/7 Inquiry Call Assist, Unity Care visit notes).
 * Colors are driven by speaker identity, not message index.
 */

export const isKathyTranscriptSpeaker = (role) =>
  String(role || "").trim() === "Kathy";

export const getTranscriptBubbleStyle = (role) => {
  const isKathy = isKathyTranscriptSpeaker(role);
  return {
    border: `1px solid ${isKathy ? "#dbeafe" : "#e2e8f0"}`,
    borderRadius: 10,
    padding: "10px 12px",
    background: isKathy ? "#eff6ff" : "#ffffff",
  };
};

export const TRANSCRIPT_BUBBLE_SPEAKER_STYLE = {
  fontWeight: 600,
  color: "#334155",
  marginBottom: 4,
};

export const TRANSCRIPT_BUBBLE_TEXT_STYLE = {
  color: "#0f172a",
};
